module.exports = __webpack_public_path__ + "img/triangle-in-shield.0371067f.svg";